import React, { Component } from 'react';

// Router
import {
  Link
} from 'react-router-dom';

// Conf
import conf from './_core/_conf';

// Core
import {Media,SiteModifier,Loader,Site,Grid,Navigation,Burger,Icon,Section,Content} from './_core/components';
import {Entry,Asset,Data} from './_core/models';
import {Template,Modal,TransitionEntry} from './_core/controllers';
import {withData,withSite} from './_core/utils';

// Project
import * as Project from './components';


class Index extends Component {


  constructor(props){

      super(props);
  }

  componentWillMount = () => {

      const _this = this;

  }



  render() {

    // Load the settings to get the manifest (JSON data to power the site)
    let settings = conf.get();
    
    return (
      <Site>

        {/* Loader - loads the manifest from settings, then outputs the page */}
        <Loader manifest={settings.MANIFEST}
            progress={
              (progress) => (
                  <div className="Site-loader"><div className={"Loader"}>{progress}%</div></div>
              )
            }
            loaded={
              () => (

                <Project.Router />
                
              )
          }
        />

      </Site>
    );
  }
}



export default withData(Index);



// WEBPACK FOOTER //
// ./src/js/index.js